import { db } from '../firebase';
import { 
  collection, 
  doc, 
  setDoc, 
  query, 
  where, 
  onSnapshot,
  orderBy,
  serverTimestamp 
} from 'firebase/firestore';

export const diaryService = {
  subscribeDiaryEntries(userId, callback) {
    const entriesRef = collection(db, 'diary');
    const q = query(
      entriesRef,
      where('userId', '==', userId),
      orderBy('createdAt', 'desc')
    );
    
    return onSnapshot(q, (snapshot) => {
      const entries = [];
      snapshot.forEach((doc) => {
        entries.push({ id: doc.id, ...doc.data() });
      });
      callback(entries);
    });
  },

  async createEntry(userId, text) {
    try {
      const entryRef = doc(collection(db, 'diary'));
      const entry = {
        userId,
        text,
        createdAt: serverTimestamp()
      };

      await setDoc(entryRef, entry);
      return { id: entryRef.id, ...entry };
    } catch (error) {
      console.error('Error creating diary entry:', error);
      throw error;
    }
  }
};